import './Card.css'
const Card = ({ img, h3, p, tech }) => {
  return (
    <div className='cardWrap'>
      <div className='card'>
        <div className='tech'>
          {tech?.map((item) => (
            <div key={item}>{item}</div>
          ))}
        </div>
        <img alt='' src={img} />
        <h3>{h3}</h3>
        <p>{p}</p>
      </div>
    </div>
  )
}

export default Card
